import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CMSApiService, CraeteManageAreaDTO } from 'features/cms/api/cms-api.service';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createManageArea } = CMSApiService();

export const useCreateManageArea = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CraeteManageAreaDTO) => {
            return createManageArea(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success(i18n.t('fields.create.successfulCreate'));
            },
        },
    );
};
